import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { detectBody } from '../../shared/helpers';
declare let Pace: any;

// init

// set jquery global
import * as $ from 'jquery';
window['jQuery'] = $;
window['$'] = $;

@Component({
    selector: 'dashboard-view',
    templateUrl: './dashboard.view.html',
    styleUrls: ['./dashboard.view.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '(window:resize)': 'onResize()'
    }
})
export class DashboardView implements OnInit {

    constructor(private router: Router) {

        let test: boolean = true;

        if (test = false) {
            this.router.navigate(['login']);
        }

        this.initDestroyTimeOutPace();
    }

    public ngOnInit(): any {
        detectBody();
    }

    public onResize() {
        detectBody();
    }

    initDestroyTimeOutPace() {
        let counter = 0;
    
        const refreshIntervalId = setInterval(function() {
            let progress; 
    
            if( typeof $( '.pace-progress' ).attr( 'data-progress-text' ) !== 'undefined' ) {
                progress = Number( $( '.pace-progress' ).attr( 'data-progress-text' ).replace("%" ,'') );
            }
    
            if( progress >= 99 ) {
                counter++;
            }
    
            if( counter > 50 ) {
                clearInterval(refreshIntervalId);
                Pace.stop();
            }
        }, 100);
    }

}
